"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ModalShare_1 = __importDefault(require("../../../components/modal/ModalShare"));
const ModalSubUser_1 = require("../../../components/modal/ModalSubUser");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const ProfileSubModal = (props) => {
    const { visible, onClose, modalPosition, userHandle } = props;
    const distanceFromBottom = react_native_1.Dimensions.get("window").height - modalPosition.y;
    const [shareModalVisible, setShareModalVisible] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
                helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
            }, onDismiss: () => {
                helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
            } },
            react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 1, style: styles.viewContain, onPress: onClose },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.viewModal,
                        {
                            position: "absolute",
                            top: distanceFromBottom > (0, scale_1.scale)(290)
                                ? modalPosition.y + (0, scale_1.scale)(8)
                                : modalPosition.y - (0, scale_1.scale)(290),
                            left: modalPosition.x - (0, scale_1.scale)(220),
                        },
                    ] },
                    react_1.default.createElement(ModalSubUser_1.MenuItemPressButton, { title: '\u5171\u6709', onPress: () => {
                            setShareModalVisible(true);
                            onClose();
                        }, style: { borderBottomColor: 'transparent' } })),
                react_1.default.createElement(react_native_1.View, { style: {
                        marginBottom: (0, scale_1.scale)(40),
                        marginTop: (0, scale_1.scale)(20),
                        maxHeight: (0, scale_1.scale)(370),
                    } }))),
        react_1.default.createElement(ModalShare_1.default, { uri: `${window.location.origin}/users/${userHandle}`, visible: shareModalVisible, onClose: () => setShareModalVisible(false) })));
};
const styles = react_native_1.StyleSheet.create({
    viewLine: {
        borderBottomWidth: (0, scale_1.scale)(1),
        borderBottomColor: "#ADADAD",
        paddingHorizontal: (0, scale_1.scale)(20),
        paddingVertical: (0, scale_1.scale)(16),
    },
    textConfirm: {
        color: "#FFFFFF",
    },
    textNote: {
        fontWeight: "300",
        fontSize: (0, scale_1.moderateScale)(14),
        color: "#292A33",
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    viewModal: {
        backgroundColor: "#DDDDDD",
        width: (0, scale_1.scale)(220),
        borderRadius: (0, scale_1.scale)(6),
        overflow: "hidden",
    },
    viewContain: {
        flex: 1,
    },
});
exports.default = ProfileSubModal;
